const Spinner=()=>{
  return(
    <>
    <div class="containerSpinner">
      <svg xmlns="http://www.w3.org/2000/svg" class="goog-te-spinner" width="8.5%" height="100%" viewBox="0 0 66 66"><circle class="goog-te-spinner-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
   </div>
    </>
    );
}
export default Spinner;